// Profile picture, or initials when there isn't one. The image URL carries
// avatar_at so a new picture busts the (long-lived) browser cache.
export function Avatar({ playerId, name, avatarAt, size = 36 }: { playerId: number; name: string; avatarAt: number | null | undefined; size?: number }) {
  const style = { width: size, height: size, fontSize: size * 0.4 };
  if (avatarAt) {
    return <img className="avatar" style={style} src={`/api/players/${playerId}/avatar?v=${avatarAt}`} alt="" loading="lazy" />;
  }
  const initials = name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]!.toUpperCase()).join("");
  return <span className="avatar avatar-initials" style={style} aria-hidden="true">{initials || "?"}</span>;
}

/** Square-crop and shrink a photo on the phone to a ~10 KB JPEG data: URL before upload. */
export async function photoToAvatar(file: File, px = 192): Promise<string> {
  const bitmap = await createImageBitmap(file);
  const side = Math.min(bitmap.width, bitmap.height);
  const canvas = document.createElement("canvas");
  canvas.width = canvas.height = px;
  canvas.getContext("2d")!.drawImage(bitmap, (bitmap.width - side) / 2, (bitmap.height - side) / 2, side, side, 0, 0, px, px);
  bitmap.close();
  return canvas.toDataURL("image/jpeg", 0.8);
}
